export default __webpack_public_path__ + "static/media/cardBack.ff40743c.jpg";